import { getConfig } from '@edx/frontend-platform';

import messages from '../../messages';

const validateUsername = (value, formatMessage) => {
  // Validates the username based on config (allows specialchars if enabled), returning an error message if invalid
  const allowSpecialChars = getConfig().ENABLE_SPECIAL_CHARS_USERNAME;
  const VALID_USERNAME_REGEX = allowSpecialChars ? /^[a-zA-Z0-9@\-._+]*$/i : /^[a-zA-Z0-9_-]*$/i;

  let fieldError = '';
  if (!value || value.length <= 1 || value.length > 30) {
    fieldError = formatMessage(messages['username.validation.message']);
  } else if (!VALID_USERNAME_REGEX.test(value)) {
    fieldError = allowSpecialChars
      ? formatMessage(messages['username.special.char.format.validation.message'])
      : formatMessage(messages['username.format.validation.message']);
  }
  return fieldError;
};

export default validateUsername;
